import customerFilter, { CustomerFilter } from '@/customer/models/CustomerFilter';
import { Broadcast , broadcast} from '@/mass/models/Broadcast';
import MassSendMsg from '../models/MassSendMsg';
import CustomerRemark from '@/customer/models/CustomerRemark';

const massSendMsg: MassSendMsg = {} as MassSendMsg;
const remarks: CustomerRemark[] = [];
const initb: Broadcast = JSON.parse(JSON.stringify(broadcast)) as Broadcast;

export interface MassState {
  broadcast: Broadcast;
  massSendMsg: MassSendMsg;
  remarks: CustomerRemark[];
}


export const massState: MassState = {
  broadcast: initb,
  massSendMsg: massSendMsg,
  remarks: remarks,
};
